import { GenericRepository } from "../generic-repository/GenericRepository";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ProductGroups } from "../../models/ProductGroups/productgroups.model";
import { IProductGroupsRepository } from "./IProductGroupsRepository";
import { environment } from "../../../environments/environment";
@Injectable()
export class ProductGroupsRepository extends GenericRepository<ProductGroups> implements IProductGroupsRepository {

    url: string = environment.urlAddress;
    constructor(protected _http: HttpClient) {
        super(_http, 'api/ProductGroups/', environment.urlAddress);
    }
    LoadRec(ProductGroupCode: string): Observable<any> {
        return this.GetById('/GetRec/' + ProductGroupCode).pipe(map(this.extractData), catchError(this.handleError));
    }
    GetNavRec(navType: number, currentIndex: number): Observable<any> {
        return this._http.get(this.url + 'api/ProductGroups/NavRec' + '/' + navType + '/' + currentIndex, this.httpOptions).pipe(map(this.extractData), catchError(this.handleError));
    }
    DeleteRec(ProductGroupCode: string) {
        return this.Delete('/DeleteRec/' + ProductGroupCode).pipe(map(this.extractData), catchError(this.handleError));
    }
    GetAll(): Observable<any> {
        return this._http.get(this.url + 'api/ProductGroups/GetAll', this.httpOptions).pipe(map(this.extractData), catchError(this.handleError));
    }
}